import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import LoaderSpin from "../components/loaderSpin/LoaderSpin";

import {
  Container,
  Row,
  Col,
  Label,
  Form,
  Nav,
  NavItem,
  NavLink,
  TabPane,
  TabContent,
} from "reactstrap";
import classnames from "classnames";
import { Grid, GridColumnMenuWrapper, GridColumn as Column } from "@progress/kendo-react-grid";
import { Tooltip } from '@progress/kendo-react-tooltip';

import { ColumnMenu } from "../components/kendoComponents/columnMenu/ColumnMenu";
import { GridPager } from "../components/kendoComponents/gridPager/GridPager";
import { ColumnProps } from "../components/kendoComponents/columnProps/ColumnProps";
import { process } from "@progress/kendo-data-query";
import moment from "moment";

import DimensionsSelector from "../components/DataQuality/DimensionsSelector";
import OtherVersionSelector from "../components/DataQuality/OtherVersionSelector";
import KeysSelector from "../components/DataQuality/KeysSelector";
import { useNavigate, useParams } from "react-router-dom";
import { SetCurrentActiveTab } from "../store/customizer/CustomizerSlice";
import { useEffectOnChange } from "../components/hooks/CustomHooks";
import "../assets/scss/kendo-theme-custom.scss";
import { CustomCell } from "../components/kendoComponents/customCell/CustomCell";
import { DateCell } from "../components/kendoComponents/dateCell/DateCell";

import {
  fetchVersionInfo,
  fetchVersionDqList,
  fetchVersionValidationHistory,
  fetchPayload,
  fetchSummary,
  fetchSummaryStructure,
  setFilterDimensions,
  fetchSummaryCounts,
  fetchCompareDimension,
  setFilterOtherVersion,
  setFilterKeys,
  fetchKeyChanges,
  fetchPayloadStructure,
  getPayloadStructure,
  getSummaryStructure,
  getSummary,
} from "../store/app/DataQualityStatus/DataQualitySlice";


import PropTypes from "prop-types";

const PayloadHeaderCell = ({ structure, ...props }) => {
  const tooltipText = structure.tooltip || structure.description || structure.id || '';

  return (
    <span className="k-cell-inner">
      <button
        style={{
          background: 'none',
          border: 'none',
          margin: 0,
          font: 'inherit',
          cursor: 'inherit',
          color: 'inherit',
        }}
        className="k-link k-tooltip-target"
        title={tooltipText}
        data-tooltip-content={tooltipText}
        type="button"
        onClick={props.onClick}
      >
        <span className="k-column-title">
          {props.title}
          {props.children}
        </span>
      </button>
      <GridColumnMenuWrapper {...props.columnMenuWrapperProps} />
    </span>
  );
};
PayloadHeaderCell.propTypes = {
  structure: PropTypes.shape({
    tooltip: PropTypes.string,
    description: PropTypes.string,
    id: PropTypes.string.isRequired,
  }).isRequired,
  title: PropTypes.node,
  onClick: PropTypes.func,
  children: PropTypes.node,
  columnMenuWrapperProps: PropTypes.object,
};


const DettaglioSingolaVersione = () => {
  const dispatch = useDispatch();
  const { versionId } = useParams();
  const navigate = useNavigate();

  const versionInfo = useSelector(
    (state) => state.dataQualityReducer.versionInfo
  );
  const refreshCount = useSelector(
    (state) => state.dataQualityReducer.refreshCount
  );

  const filterDimensions = useSelector(
    (state) => state.dataQualityReducer.filterDimensions
  );
  const payload = useSelector(
    (state) => state.dataQualityReducer.payload || []
  );
  const summary = useSelector(
    (state) => state.dataQualityReducer.summary || []
  );
  const dimensions = useSelector(
    (state) => state.dataQualityReducer.dimensions
  );
  const payloadStructure = useSelector(
    (state) => state.dataQualityReducer.payloadStructure || []
  );
  const summaryStructure = useSelector(
    (state) => state.dataQualityReducer.summaryStructure || []
  );

  const comparedVersions = useSelector(
    (state) => state.dataQualityReducer.comparedVersions || []
  );

  const keyChanges = useSelector(
    (state) => state.dataQualityReducer.keyChanges || []
  );

  const filterOtherVersion = useSelector(
    (state) => state.dataQualityReducer.filterOtherVersion
  );

  const filterKey = useSelector((state) => state.dataQualityReducer.filterKeys);

  const isSpinnerVisible = useSelector(
    (state) => state.dataQualityReducer.loading
  );



  const [dataStatePayload, setDataStatePayload] = useState({
    sort: [
      {
        field: "code",
        dir: "asc",
      },
    ],
    skip: 0,
    take: 20,
  });

  const [dataStateSummary, setDataStateSummary] = useState({
    sort: [
      {
        field: "code",
        dir: "asc",
      },
    ],
    skip: 0,
    take: 20,
  });

  const [dataStateComparedVersion, setDataStateComparedVersion] = useState({
    sort: [
      {
        field: "code",
        dir: "asc",
      },
    ],
    skip: 0,
    take: 20,
  });

  const [dataStateKeyChanges, setDataStateKeyChanges] = useState({
    sort: [
      {
        field: "code",
        dir: "asc",
      },
    ],
    skip: 0,
    take: 20,
  });

  const [dataResultPayload, setDataResultPayload] = useState(
    process(payload, dataStatePayload)
  );

  const [dataResultSummary, setDataResultSummary] = useState(
    process(summary, dataStateSummary)
  );

  const [dataResultComparedVersion, setDataResultComparedVersion] = useState(
    process(comparedVersions, dataStateComparedVersion)
  );

  const [dataResultkeyChanges, setDataResultkeyChanges] = useState(
    process(comparedVersions, dataStateComparedVersion)
  );

  useEffect(() => {
    dispatch(fetchVersionInfo(versionId));
    dispatch(fetchVersionDqList(versionId));
    dispatch(fetchVersionValidationHistory(versionId));
    dispatch(fetchPayloadStructure(versionId));

    return () => {
      dispatch(setFilterDimensions([]));
      dispatch(SetCurrentActiveTab("1"));
      dispatch(setFilterOtherVersion({}));
      dispatch(setFilterKeys({}));
      dispatch(getPayloadStructure([]));
      dispatch(getSummaryStructure([]));
    };
  }, [navigate, refreshCount]);

  useEffectOnChange(() => {
    if (
      dimensions.length > 0 &&
      versionInfo.class_name != "Map" &&
      versionInfo.class_name != "Dimension"
    ) {
      dispatch(setFilterDimensions([dimensions[0].id]));
      dispatch(fetchSummaryStructure(versionId, dimensions));
    }
  }, [dimensions]);

  useEffectOnChange(() => {
    if (payloadStructure.length > 0) {
      dispatch(fetchPayload(versionId));
    }
  }, [payloadStructure]);

  useEffectOnChange(() => {
    if (summaryStructure.length > 0 && filterDimensions.length > 0) {
      dispatch(fetchSummary(versionId, filterDimensions));
      dispatch(fetchSummaryCounts(versionId));
    } else if (filterDimensions.length == 0) {
      // reset summary if no dimensions selected
      dispatch(getSummary([]));
    }
  }, [summaryStructure, filterDimensions]);

  useEffect(() => {
    setDataStatePayload((prev) => ({
      ...{
        sort: [
          {
            field: "code",
            dir: "asc",
          },
        ],
      },
      skip: 0,
      take: 20,
    }));
    setDataResultPayload(process(payload, dataStatePayload));
  }, [payload]);

  useEffect(() => {
    setDataStateSummary((prev) => ({
      ...{
        sort: [
          {
            field: "code",
            dir: "asc",
          },
        ],
      },
      skip: 0,
      take: 20,
    }));
    setDataResultSummary(process(summary, dataStateSummary));
  }, [summary]);

  useEffectOnChange(() => {
    if (
      (versionInfo.class_name == "Map" ||
        versionInfo.class_name == "Dimension") &&
      filterOtherVersion.version_id
    ) {
      dispatch(fetchCompareDimension(versionId, filterOtherVersion.version_id));
    }
  }, [filterOtherVersion]);

  useEffectOnChange(() => {
    if (
      (versionInfo.class_name == "Map" ||
        versionInfo.class_name == "Dimension") &&
      filterKey.obj
    )
      dispatch(fetchKeyChanges(versionId, filterKey));
  }, [filterKey]);

  useEffect(() => {
    setDataStateComparedVersion((prev) => ({
      ...{
        sort: [
          {
            field: "code",
            dir: "asc",
          },
        ],
      },
      skip: 0,
      take: 20,
    }));
    setDataResultComparedVersion(
      process(comparedVersions, dataStateComparedVersion)
    );
  }, [comparedVersions]);

  useEffect(() => {
    setDataStateKeyChanges((prev) => ({
      ...{
        sort: [
          {
            field: "code",
            dir: "asc",
          },
        ],
      },
      skip: 0,
      take: 20,
    }));
    setDataResultkeyChanges(process(keyChanges, dataStateKeyChanges));
  }, [keyChanges]);

  const renderPayloadHeaderCell = (props, structure) => (
    <PayloadHeaderCell structure={structure} {...props} />
  );

  const calculateColumnWidth = (fieldName, data, minWidth = 100, maxWidth = 400) => {
    // Start with the header text length
    let maxLength = fieldName.length;

    // Find the maximum length in the data for this field
    if (data && data.length > 0) {
      for (const row of data) {
        const value = row[fieldName];
        if (value !== null && value !== undefined) {
          const valueLength = String(value).length;
          if (valueLength > maxLength) {
            maxLength = valueLength;
          }
        }
      }
    }

    // Approximate 8 pixels per character + padding
    const calculatedWidth = Math.max(maxLength * 8 + 40, minWidth);
    return Math.min(calculatedWidth, maxWidth);
  };

  const mapGridPayload = (structure, index) => {
    const columnWidth = calculateColumnWidth(structure.id, payload);
    return (
      <Column
        {...ColumnProps(structure.id, dataStatePayload)}
        key={index}
        field={structure.id}
        title={structure.id}
        columnMenu={ColumnMenu}
        headerCell={(props) => renderPayloadHeaderCell(props, structure)}
        cell={(props) => CustomCell(props, structure.description)}
        width={columnWidth}
      />
    );
  };


  const mapGridSummary = (structure, index) => (
    <Column
      {...ColumnProps(structure.id, dataStateSummary)}
      key={index}
      title={structure.id}
      cell={(props) => CustomCell(props, structure.description)}
      width={150}
    />
  );

  const currentActiveTab = useSelector(
    (state) => state.customizer.currentActiveTab
  );

  // Toggle active state for Tab
  const toggle = (tab) => {
    if (currentActiveTab !== tab) dispatch(SetCurrentActiveTab(tab));
  };

  return (
    <>
      <Form>
        {/* Single Row: Version Info */}
        <Row className="bg-light-primary px-4 py-2">
          <Col>
            <Row className="align-items-center g-3">
              <Col xs="12" md="auto" lg="auto" className="d-flex flex-column min-w-0">
                <Label for="version_id" className="mb-1 small">Version ID</Label>
                <span className="form-control-plaintext mb-0 px-2 py-1 text-truncate w-100 d-inline-block">
                  {versionInfo.version_id}
                </span>
              </Col>

              <Col xs="12" md="auto" lg="auto" className="d-flex flex-column min-w-0">
                <Label for="data_product" className="mb-1 small">Data Product</Label>
                <button
                  type="button"
                  className="form-control-plaintext mb-0 px-2 py-1 border border-primary rounded bg-medium-primary text-truncate w-100 d-inline-block text-start"
                  onClick={() => {
                    const searchParams = new URLSearchParams(location.search);
                    navigate("/data-catalog/details/" + versionInfo.product_type_id + "?" + searchParams.toString());
                  }}
                  title={versionInfo.product_name}
                >
                  {versionInfo.product_name}
                </button>
              </Col>

              <Col xs="12" md="auto" lg="auto" className="d-flex flex-column min-w-0">
                <Label for="reference_date" className="mb-1 small">Reference Date</Label>
                <span className="form-control-plaintext mb-0 px-2 py-1 text-truncate w-100 d-inline-block">
                  {moment(versionInfo.reference_date).format("DD/MM/YYYY")}
                </span>
              </Col>

              <Col xs="12" md="auto" lg="auto" className="d-flex flex-column min-w-0">
                <Label for="purpose" className="mb-1 small">Purpose</Label>
                <span
                  className="form-control-plaintext mb-0 px-2 py-1 text-truncate w-100 d-inline-block"
                  title={versionInfo.purpose}
                >
                  {versionInfo.purpose || "N/A"}
                </span>
              </Col>

              <Col xs="12" md="auto" lg="auto" className="d-flex flex-column min-w-0">
                <Label for="validation_type" className="mb-1 small">Validation Type</Label>
                <span className="form-control-plaintext mb-0 px-2 py-1 text-truncate w-100 d-inline-block">
                  {versionInfo.is_manual_validation ? "Manual" : "Automatic"}
                </span>
              </Col>

              <Col xs="12" md="auto" lg="auto" className="d-flex flex-column min-w-0">
                <Label for="version_status" className="mb-1 small">Version Status</Label>
                <span
                  className="form-control-plaintext mb-0 px-2 py-1 text-truncate w-100 d-inline-block"
                  title={`${versionInfo.status_name} - ${versionInfo.ext_status_name}`}
                >
                  {versionInfo.status_name} - {versionInfo.ext_status_name}
                </span>
              </Col>
            </Row>
          </Col>
        </Row>
      </Form>

      <Container fluid className="py-2 px-4  position-relative">
        <Row className="row mt-2">
          <Col>
            <Nav pills>
              <NavItem>
                <NavLink
                  className={classnames({
                    active: currentActiveTab === "1",
                  })}
                  onClick={() => {
                    toggle("1");
                  }}
                >
                  Detail
                </NavLink>
              </NavItem>
              {versionInfo.class_name != "Map" &&
                versionInfo.class_name != "Dimension" && (
                  <NavItem>
                    <NavLink
                      disabled={dimensions.length == 0}
                      className={classnames({
                        active: currentActiveTab === "2",
                      })}
                      onClick={() => toggle("2")}
                    >
                      Summary
                    </NavLink>
                  </NavItem>
                )}
              {(versionInfo.class_name == "Map" ||
                versionInfo.class_name == "Dimension") && (
                  <>
                    <NavItem>
                      <NavLink
                        className={classnames({
                          active: currentActiveTab === "3",
                        })}
                        onClick={() => toggle("3")}
                      >
                        Comparison
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({
                          active: currentActiveTab === "4",
                        })}
                        onClick={() => toggle("4")}
                      >
                        History
                      </NavLink>
                    </NavItem>
                  </>
                )}
            </Nav>
            <TabContent activeTab={currentActiveTab}>
              <TabPane
                className="grid_task_container_tabs_fixed border border-top-0"
                tabId="1"
              >
                <div
                  className="position-relative"
                  style={{ height: "calc(100% - 70px)" }}
                >
                  <div className="position-absolute w-100 h-100 top-0 start-0">
                    <Tooltip anchorElement="target" openDelay={0} position="top">
                      <Grid
                        style={{ height: "100%" }}
                        data={dataResultPayload}
                        {...dataStatePayload}
                        sortable
                        pageable
                        total={dataResultPayload?.length}
                        pager={(props) => GridPager(props, payload, "payload")}
                        onDataStateChange={(e) => {
                          setDataStatePayload(e.dataState);
                          setDataResultPayload(process(payload, e.dataState));
                        }}
                      >
                        {payloadStructure?.map(mapGridPayload)}
                      </Grid>
                    </Tooltip>
                  </div>
                </div>
              </TabPane>

              {versionInfo.class_name != "Map" &&
                versionInfo.class_name != "Dimension" && (
                  <TabPane
                    className="grid_task_container_tabs_fixed border border-top-0"
                    tabId="2"
                  >
                    <Row className="mx-0 bg-light-primary">
                      <Col md="auto" className="ms-auto">
                        <Row className="align-items-center my-3 pe-3">
                          <Col md="auto">
                            <Label for="categoryName">Dimensions</Label>
                          </Col>
                          <Col>
                            <DimensionsSelector />
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                    <div
                      className="position-relative"
                      style={{ height: "calc(100% - 70px)" }}
                    >
                      <div className="position-absolute w-100 h-100 top-0 start-0">
                        <Grid
                          style={{ height: "100%" }}
                          data={dataResultSummary}
                          {...dataStateSummary}
                          pageable={true}
                          total={dataResultSummary?.length}
                          pager={(props) => GridPager(props, summary)} //Rimosso finche non trobiamo una soluzione per l'export di tutti i dati
                          onDataStateChange={(e) => {
                            setDataStateSummary(e.dataState);
                            setDataResultSummary(process(summary, e.dataState));
                          }}
                        >
                          {summaryStructure?.map(mapGridSummary)}
                          <Column />
                        </Grid>
                      </div>
                    </div>
                  </TabPane>
                )}

              {(versionInfo.class_name == "Map" ||
                versionInfo.class_name == "Dimension") && (
                  <>
                    <TabPane
                      className="grid_task_container_tabs_fixed border border-top-0"
                      tabId="3"
                    >
                      <Row className="mx-0 bg-light-primary">
                        <Col>
                          <Row className="align-items-stretch mt-3 pe-3"></Row>
                        </Col>
                        <Col md="4" className="ms-auto">
                          <Row className="align-items-center my-3 pe-3">
                            <Col md="auto">
                              <Label for="categoryName">
                                Compare with Version{" "}
                              </Label>
                            </Col>
                            <Col>
                              <OtherVersionSelector />
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                      <div
                        className="position-relative"
                        style={{ height: "calc(100% - 70px)" }}
                      >
                        <div className="position-absolute w-100 h-100 top-0 start-0">
                          <Grid
                            style={{ height: "100%" }}
                            data={dataResultComparedVersion}
                            {...dataStateComparedVersion}
                            pageable={{ buttonCount: 8 }}
                            total={dataResultComparedVersion?.length}
                            pager={(props) => GridPager(props, comparedVersions)}
                            onDataStateChange={(e) => {
                              setDataStateComparedVersion(e.dataState);
                              setDataResultComparedVersion(
                                process(comparedVersions, e.dataState)
                              );
                            }}
                          >
                            <Column
                              {...ColumnProps(
                                "diff_type",
                                dataStateComparedVersion
                              )}
                              title="Difference Type"
                            />
                            <Column
                              {...ColumnProps("key", dataStateComparedVersion)}
                              title="Key"
                            />
                            <Column
                              {...ColumnProps(
                                "latest_non_key_values",
                                dataStateComparedVersion
                              )}
                              title="Latest Non-Key Values"
                            />{" "}
                            <Column
                              {...ColumnProps(
                                "previous_non_key_values",
                                dataStateComparedVersion
                              )}
                              title="Previous Non-Key Values"
                            />
                          </Grid>
                        </div>
                      </div>
                    </TabPane>

                    <TabPane
                      className="grid_task_container_tabs_fixed border border-top-0"
                      tabId="4"
                    >
                      <Row className="mx-0 bg-light-primary">
                        <Col>
                          <Row className="align-items-stretch mt-3 pe-3"></Row>
                        </Col>
                        <Col md="4" className="ms-auto">
                          <Row className="align-items-center my-3 pe-3">
                            <Col md="auto">
                              <Label for="categoryName">Key </Label>
                            </Col>
                            <Col>
                              <KeysSelector />
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                      <div
                        className="position-relative"
                        style={{ height: "calc(100% - 70px)" }}
                      >
                        <div className="position-absolute w-100 h-100 top-0 start-0">
                          <Grid
                            style={{ height: "100%" }}
                            data={dataResultkeyChanges}
                            {...dataStateKeyChanges}
                            pageable={{ buttonCount: 8 }}
                            total={dataResultkeyChanges?.length}
                            pager={(props) => GridPager(props, keyChanges)}
                            onDataStateChange={(e) => {
                              setDataStateKeyChanges(e.dataState);
                              setDataResultkeyChanges(
                                process(keyChanges, e.dataState)
                              );
                            }}
                          >
                            <Column
                              {...ColumnProps("version_id", dataStateKeyChanges)}
                              title="version_id"
                            />
                            <Column
                              {...ColumnProps("change_type", dataStateKeyChanges)}
                              title="change_type"
                            />
                            <Column
                              {...ColumnProps(
                                "non_key_values",
                                dataStateKeyChanges
                              )}
                              title="non_key_values"
                            />
                            <Column
                              {...ColumnProps(
                                "reference_date",
                                dataStateKeyChanges
                              )}
                              cell={(props) => DateCell(props, false)}
                              title="reference_date"
                            />
                          </Grid>
                        </div>
                      </div>
                    </TabPane>
                  </>
                )}
            </TabContent>
          </Col>
        </Row>
        <LoaderSpin isVisible={isSpinnerVisible} />
      </Container>
    </>
  );
};

export default DettaglioSingolaVersione;
